module.exports = __webpack_public_path__ + "img/pandemic_affected.9c9a316d.svg";